module.exports = __webpack_public_path__ + "img/Revenue Icon - charcoal.cac58c4b.svg";